<template>
  <div class="brand-wrap flex justify-center items-center">
    <div class="img-wrap">
      <router-link to="/">
        <img
          :src="logoSrc"
          alt="Logo"
        >
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType  } from 'vue';
import logo from '@/assets/logo.svg';
import logoSmall from '@/assets/logo_small.svg';

export default defineComponent({
  name: 'LecLogo',
  props: {
    small: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props) {
        const logoSrc = computed(() => {
            return props.small ? logoSmall : logo;
        });
        return { logoSrc };
    },
});
</script>

<style scoped lang="scss">
.brand-wrap {
  //padding: 0.5rem 1rem 0.5rem 0.5rem;

  .img-wrap {
    display: inline-block;
    position: relative;
  }

  img {
    height: auto;
  }

  &.shrink img {
    width: 100%;
  }

  .logo-banner {
    top: 50%;
    margin-top: .5rem;
    right: 0;
    position: absolute;
    text-align: center;
    color: var(--color-secondary-red-full);
    font-weight: bold;
    rotate: -23deg; 
  }
}
</style>